<template>
	<div>
	   <el-row style="height:80px;">
	     <el-col :span="16">
			 <div class="navlist">
				   <h1>{{site_title}}</h1>
				   <router-link to="/serviceHome/serviceindex" active-class="active-link">首页</router-link>
				   <router-link to="/serviceHome/serviceOrder" active-class="active-link">我的订单</router-link>
				   <router-link to="/serviceHome/invitedList"  active-class="active-link">被邀标</router-link>
				   <router-link to="/serviceHome/myQuote" active-class="active-link">我的报价</router-link>
				   <el-dropdown>
						<span class="nav-item" :class="{ 'active-link': isPersonalCenterActive }">个人中心<i class="el-icon-arrow-down el-icon--right"></i></span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item>
								<router-link to="/serviceHome/MyWallet" active-class="active-link">
									我的钱包
								</router-link>
							</el-dropdown-item>
							<el-dropdown-item>
								<router-link to="/serviceHome/MyReview" active-class="active-link">
									我的评审
								</router-link>
							</el-dropdown-item>
							<el-dropdown-item>
								<router-link to="/serviceHome/UserInfo" active-class="active-link">
									个人信息
								</router-link>
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
			 </div>  
		</el-col>
	    <el-col :span="4" style="display:flex;">
			<div class="disng">
				<img src="@/assets/lingdan.png" alt="" sizes="" srcset=""   class="disng1" @click="message"/>
				<img :src="userinfo.avatar" alt="" sizes="" srcset=""   class="disng2"/>
			 </div>
		</el-col>
	   </el-row>
	   <router-view></router-view>
	</div>
</template>

<script>
	import { personal,BaseGetConfig} from '@/api/api'
	export default {
	  computed: {
		isPersonalCenterActive() {
		  const p = this.$route && this.$route.path ? this.$route.path : ''
		  return /^\/serviceHome\/(MyWallet|MyReview|UserInfo)(\/|$)/.test(p)
		}
	  },
	  data() {
	    return {
			userinfo:"",
			logo:"",
			site_title:""
		}
	   },
	   created() {
	   	 this.getpersonal()
	   	 this.getBaseGetConfig()
		 this.logo=localStorage.getItem("logo")
		 this.site_title=localStorage.getItem("site_title")
		 console.log(this.site_title)
	   },
	    methods: {
			getBaseGetConfig(){
				BaseGetConfig({
					key:"demand_file_config,demand_off_time"
				}).then(res=>{
					this.demand_file_config=res.data.demand_file_config
					this.demand_off_time=res.data.demand_off_time
				})
			},
			getpersonal(){
				personal({}).then(res=>{
					this.userinfo=res.data.data
					localStorage.setItem("userinfo",this.userinfo)
				})
			},
			message(){
				if (this.$route.path !== '/serviceHome/messagelist') {
				    this.$router.push('/serviceHome/messagelist')
				}
			}
		}
	}
</script>

<style scoped>
	.el-row {
		width:100%;
		background-color:#fff;
		display:flex;
		justify-content:space-between;
		align-items: center;
	}
	.active-link{
		color:#1E3A8A ;
	}
	.navlist{
		display:flex;
		align-items: center;
	}
	.navlist a{
		font-weight: bold;
		font-size: 20px;
		margin-left:72px;
		color:#999999;
	}
	.nav-item {
	  font-weight: bold;
	  font-size: 20px;
	  margin-left: 72px;
	  cursor: pointer;
	  display: inline-flex;
	  align-items: center;
	}
	
	.nav-item .el-icon-arrow-down {
	  font-size: 14px;
	  margin-left: 4px;
	}
	::v-deep .el-dropdown{
		color:#999999;
	}
	::v-deep .active-link{
	    color: #1E3A8A !important;
	}
	.disng{
		display:flex;
		align-items: center;
	}
	.disng1{
		width:24px;
		height:24px;
		margin-left:24px;
		cursor:pointer;
	}
	.disng2{
		width:32px;
		height:32px;
		border-radius:50%;
		margin-left:24px;
		cursor:pointer;
	}
</style>